import { Helmet } from 'react-helmet-async'
import { seoToHelmet } from './metadata'
import { DEFAULT_OG_IMAGE, SITE_NAME, getSeoForPath } from './site'

export function PageSeo({ path }: { path: string }) {
  const seo = getSeoForPath(path)
  const tags = seoToHelmet(seo)
  const image = seo.ogImage || DEFAULT_OG_IMAGE

  return (
    <Helmet>
      <html lang="en-CA" />
      <title>{tags.title}</title>
      <meta name="description" content={tags.description} />
      <link rel="canonical" href={tags.canonical} />
      {!tags.index && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={tags.ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={tags.title} />
      <meta property="og:description" content={tags.description} />
      <meta property="og:url" content={tags.canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_CA" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={tags.title} />
      <meta name="twitter:description" content={tags.description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}
